import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppState } from '../../../../@store/app.reducers';
import { Store } from '@ngrx/store';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { FormArray, FormControl, FormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalConsultarTercerosComponent } from '../../@modals/modal-consultar-terceros/modal-consultar-terceros.component';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from '../../../../@store/actions';
import { CoberturaServicios, ConsultaSiniestroOutput, Servicio, TerceroComplemento } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { importeMayorACeroValidator, importeMayorASumAsegValidator } from '../../@validators/validators-complemento';
import { SiniestroCompleState } from '../../@store/complemento-web/complemento-web.models';
import { FechaUtils } from '../../@helper/fechas.utils';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { NgClass, SlicePipe } from '@angular/common';
import { MatButton, MatMiniFabButton } from '@angular/material/button';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';

@Component({
    selector: 'app-crear-actualizar-servicios-tercero',
    templateUrl: './crear-actualizar-servicios-tercero.component.html',
    styleUrls: ['./crear-actualizar-servicios-tercero.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatButton, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, PaginaDatosTablaComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatMiniFabButton, MatIcon, UpperCaseTextDirective, MatError, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatCheckbox, FormatoNumeroMonedaCoplementoWebDirective, SlicePipe]
})
export class CrearActualizarServiciosTerceroComponent implements OnInit, AfterViewInit {

  @ViewChild('terceros') paginator: MatPaginator;

  @Input() public datosServiciosTerceros = new MatTableDataSource([]);

  @Output() eventosServiciosTercero = new EventEmitter<{ nombre: string, valor: any }>();

  public displayColumns = ['TipoTercero', 'Servicio', 'Reporte', 'Estatus', 'Acciones'];

  public columnasCoberturas: string[] = ['activa', 'cobertura', 'estimacion', 'deducible', 'extra', 'subcobertura'];

  public formAsegurado: FormGroup;
  public servicioSelecciona = null;
  public habilitaTercero = false;
  public habilitaMotivoEstatus = false;
  public catServicio = [];
  public catGrua = [];
  public catConsultaEventoServicio = [];
  public catConsultaEstatusConcepto = [];
  public catConsultaEstatus = [];
  public catConsultaTipoPase = [];
  public catConsultaTradcionalTipo = [];
  private formSubscripciones = new Subscription();

  public catSiNo = [
    { id: 0, nombre: 'NO' },
    { id: 1, nombre: 'SI' }
  ];
  public catMP = [
    { id: 2, nombre: 'NO' },
    { id: 1, nombre: 'SI' }
  ];

  public horas = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  public minutos = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };

  public listaObservables = new Subscription();
  public servicioDetalle: Servicio;
  public coberturasDetalle: CoberturaServicios[];
  public siniestroConsultado: string;
  public detalleSiniestroBase: SiniestroCompleState;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private complementoWebService: ComplementoWebService,
    private procesosComplementoService: ProcesosComunesComplementoService
  ) {
    this.crearFormulario();
    this.obtenerReduxState();
    this.obtenerCatalogos();
  }

  ngOnInit(): void {
    this.cambiosFormulario();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;
    });
    this.listaObservables.add(subsComplemento);
  }

  ngAfterViewInit(): void {
  }

  obtenerCatalogos() {
    this.store.select(selectListaCatalogosSiniestros).subscribe({
      next: (value) => {
        this.catGrua = value.consultaTipoGrua;
        this.catConsultaEstatus = value.consultaEstatusAbogado;
        this.catConsultaEstatusConcepto = value.consultaEstatusConcepto;
        this.catConsultaEventoServicio = value.consultaEventoServicio;
        this.catConsultaTipoPase = value.consultaTipoPase;
        this.catConsultaTradcionalTipo = value.consultaTradicionalTipo;
        this.catServicio = value.consultaTipoServicios;
      },
    });
  }

  crearFormulario() {
    this.formAsegurado = new FormGroup({
      idTercero: new FormControl(null),
      tipoPrestador: new FormControl(null),
      servicio: new FormControl(null),
      tipoTercero: new FormControl({ value: null, disabled: true }),
      tipoProveedor: new FormControl(null),
      proveedor: new FormControl(null),
      reporte: new FormControl({ value: null, disabled: true }),
      coberturas: new FormArray([]),

      horasTiempo: new FormControl(null),
      minutosTiempo: new FormControl(null),
      maniobraMayor: new FormControl(null),
      gruaRescate: new FormControl(null),
      tipoGrua: new FormControl(null),
      blindaje: new FormControl(null),
      evento: new FormControl(null),
      resguardo: new FormControl(null),
      concecionada: new FormControl(null),
      foraneo: new FormControl(null),

      estatus: new FormControl(null),
      arribo: new FormControl(null),
      medicoResponsiva: new FormControl(null),

      lesionado: new FormControl(null),
      homicidio: new FormControl(null),
      totallesionado: new FormControl(null),
      totalhomicidio: new FormControl(null),
      danosMateriales: new FormControl(null),
      danosEcologicos: new FormControl(null),
      ataquesViaComunicacion: new FormControl(null),
      motivoEstatus: new FormControl(null),
      mp: new FormControl(null, []),
      numeroActaMP: new FormControl(null),

      tipoLesion: new FormControl(null),
      nombreLesionado: new FormControl(null),
      apellidoPaterno: new FormControl(null),
      apellidoMaterno: new FormControl(null),
      edad: new FormControl(null),
      importe: new FormControl(null, []),

      fechaArribo: new FormControl(null),
      horaArribo: new FormControl(null),
      minutosArribo: new FormControl(null),

    })
  }

  cambiosFormulario() {
    this.formSubscripciones.unsubscribe();
    this.formSubscripciones = new Subscription();

    const subsServicio = this.formAsegurado.get('servicio')?.valueChanges.subscribe(servicio => {
      //Grua y ambulancia
      if ([5, 16].includes(servicio)) {
        return this.actualizaValidadores(this.formAsegurado, [
          'estatus',
        ], 'agregar', [Validators.required]);
      } else {
        this.actualizaValidadores(this.formAsegurado, [
          'estatus',
        ], 'quitar', [Validators.required]);
      }
      // Hospitales y doctores
      if ([10, 17].includes(servicio)) {
        return this.actualizaValidadores(this.formAsegurado, [
          'nombreLesionado',
          'apellidoPaterno',
          'apellidoMaterno',
          'edad',
        ], 'agregar', [Validators.required]);
      } else {
        this.actualizaValidadores(this.formAsegurado, [
          'nombreLesionado',
          'apellidoPaterno',
          'apellidoMaterno',
          'edad',
        ], 'quitar', [Validators.required]);
      }
    });

    const subsEstatus = this.formAsegurado.get('estatus')?.valueChanges.subscribe(estatus => {
      // Grua
      if ([5].includes(this.formAsegurado.get('servicio').value) && this.formAsegurado.get('evento').value != 2 && estatus == 1) {
        this.formAsegurado.get('evento')?.setValidators(Validators.required);
        this.formAsegurado.get('evento')?.updateValueAndValidity({ emitEvent: false });
        return this.actualizaValidadores(this.formAsegurado, [
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'agregar', [Validators.required]);
      } else {
        this.actualizaValidadores(this.formAsegurado, [
          'evento',
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'quitar', [Validators.required]);
      }
      // Abogados
      if ([15].includes(this.formAsegurado.get('servicio').value) && this.formAsegurado.get('evento').value != 2 && estatus == 1) {
        return this.actualizaValidadores(this.formAsegurado, [
          'mp',
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'agregar', [Validators.required]);
      } else {
        this.actualizaValidadores(this.formAsegurado, [
          'mp',
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'quitar', [Validators.required]);
      }
      // Ambulancia
      if ([16].includes(this.formAsegurado.get('servicio').value) && this.formAsegurado.get('evento').value != 2 && estatus == 1) {
        this.formAsegurado.get('estatus')?.setValidators(Validators.required);
        this.formAsegurado.get('estatus')?.updateValueAndValidity({ emitEvent: false });
        return this.actualizaValidadores(this.formAsegurado, [
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'agregar', [Validators.required]);
      } else {
        this.actualizaValidadores(this.formAsegurado, [
          'estatus',
          'horaArribo',
          'minutosArribo',
          'fechaArribo',
        ], 'quitar', [Validators.required]);
      }
    });

    const subsTipoEventoGrua = this.formAsegurado.get('evento')?.valueChanges.subscribe(evento => {
      if (evento == 2 && this.formAsegurado.get('servicio').value == 5) {
        this.formAsegurado.get('concecionada').setValidators(Validators.required);
        this.formAsegurado.get('concecionada').updateValueAndValidity();
      } else {
        this.formAsegurado.get('concecionada').setValidators(null);
        this.formAsegurado.get('concecionada').updateValueAndValidity();
      }
    });
    const subcCheckLesionado = this.formAsegurado.get('lesionado')?.valueChanges.subscribe(mp => {
      if (this.detalleSiniestroCompleto.Siniestro[0].causa != 3 && mp == 1) {
        this.formAsegurado.get('totallesionado').setValidators([Validators.required]);
        return this.formAsegurado.get('totallesionado').updateValueAndValidity();
      } else {
        this.formAsegurado.get('totallesionado').setValidators(null);
        return this.formAsegurado.get('totallesionado').updateValueAndValidity();
      }
    });
    const subcCheckHomicidio = this.formAsegurado.get('homicidio')?.valueChanges.subscribe(mp => {
      if (this.detalleSiniestroCompleto.Siniestro[0].causa != 3 && mp == 1) {
        this.formAsegurado.get('totalhomicidio').setValidators([Validators.required]);
        return this.formAsegurado.get('totalhomicidio').updateValueAndValidity();
      } else {
        this.formAsegurado.get('totalhomicidio').setValidators(null);
        return this.formAsegurado.get('totalhomicidio').updateValueAndValidity();
      }
    });

    this.formSubscripciones.add(subsServicio);
    this.formSubscripciones.add(subsEstatus);
    this.formSubscripciones.add(subsTipoEventoGrua);
    this.formSubscripciones.add(subcCheckHomicidio);
    this.formSubscripciones.add(subcCheckLesionado);
  }

  agregarCoberturas(cobertura?: CoberturaServicios) {
    const coberturaUno = cobertura?.cve_coberturak == 1;
    const ordenServicio = this.servicioDetalle.tipo_prestador == 1 ? coberturaUno ? cobertura?.orden_servicio == 1 ? true : false : false : false;
    const estimado = cobertura?.estimado == null ? ordenServicio ? '0' : '' : cobertura?.estimado?.replace(/[$,]/g, "");
    const estimadoDifCero = parseFloat(estimado) > 0;
    const { conDeducible, disabledConDedu } = this.validaCamposCobertura(cobertura);
    return new FormGroup({
      activa: new FormControl((estimado.length == 0 ? false : (coberturaUno || estimadoDifCero))),
      cobertura: new FormControl(cobertura?.des_coberturak),
      estimacion: new FormControl({ value: estimado, disabled: ((coberturaUno || estimadoDifCero ? false : true)) }, [importeMayorASumAsegValidator(cobertura?.suma_aseg)]),
      deducible: new FormControl({ value: conDeducible, disabled: disabledConDedu }),
      porcentajeDeducible: new FormControl({ value: cobertura.porc_deduc, disabled: disabledConDedu }),
      claveCobertura: new FormControl(cobertura?.cve_coberturak),
      orden_servicio: new FormControl(cobertura?.orden_servicio),
      sumaAsegurada: new FormControl(cobertura?.suma_aseg),
      extra: new FormControl(this.servicioDetalle.tipo_prestador == 1 && coberturaUno && parseFloat(estimado) == 0 ? 'ORDEN POR SERVICIO' : null),
      stCobertura: new FormControl(cobertura?.nota),
    })
  }

  validaCamposCobertura(cobertura?: CoberturaServicios) {
    const tipoPrestador = this.servicioDetalle.tipo_prestador;
    const responsable = this.detalleSiniestroCompleto.Siniestro[0].respons_sini;
    const causa = this.detalleSiniestroCompleto.Siniestro[0].causa;
    let valida = false;
    let disabledConDedu = false;
    let conDeducible = cobertura?.con_deducible ?? responsable == 1 ? 1 : causa == 6 ? 1 : 0;

    switch (tipoPrestador) {
      case 3:
        valida = true; //Cristalera va disabled el combo de deducible
        break;
      default:
        switch (causa) {
          case 2: //Rotura de cristal
            valida = true;
            break;
          default:
            disabledConDedu = causa == 6;
        }
    }

    if (valida) {
      conDeducible = 1;
      disabledConDedu = true;
    }

    return {
      conDeducible,
      disabledConDedu
    }
  }

  ejecutaAccionesCoberturas(coberturaControl: FormGroup, accion: string): void {

    const tipoServicio = this.servicioDetalle?.tipo_prestador;
    const cobertura = coberturaControl.get('claveCobertura')?.value;
    const estimacionControl = coberturaControl.get('estimacion');
    const sumaAsegControl = coberturaControl.get('sumaAsegurada').value;

    const acciones = {
      requiereEstimacion: () => {
        const activa = coberturaControl.get('activa')?.value;

        let esExtraRequerido = true;

        if (activa) {
          if (cobertura == 1 && tipoServicio == 1) {
            esExtraRequerido = false;
          }

          estimacionControl?.enable();
          // Agrega validaciones personalizadas si es necesario
          if (esExtraRequerido) {
            estimacionControl?.setValidators([Validators.required, importeMayorACeroValidator(), importeMayorASumAsegValidator(sumaAsegControl)]);
            estimacionControl?.setErrors({ extraRequerido: true });
          } else {
            estimacionControl?.setValidators(null);
            estimacionControl?.setErrors(null);
          }

        } else {
          estimacionControl?.setValue('');
          estimacionControl?.disable();
          estimacionControl?.clearValidators();
          estimacionControl?.setErrors(null);
        }

        estimacionControl?.updateValueAndValidity();
      },
      colocaOrdenServicio: () => {
        const estimacion = estimacionControl?.value;
        if (tipoServicio == 1) {
          if (!estimacion || parseFloat(estimacion) < 1) {
            coberturaControl.get('extra')?.setValue('ORDEN POR SERVICIO');
          } else {
            coberturaControl.get('extra')?.setValue('');
          }
        } else {
          coberturaControl.get('extra')?.setValue('');
        }
      },
      default: () => { }
    }

    return Object.keys(acciones).includes(accion) ? acciones[accion]() : acciones.default();
  }

  get coberturas(): FormArray {
    return this.formAsegurado.get('coberturas') as FormArray;
  }

  agregarCobertura(cobertura?) {
    this.coberturas.push(this.agregarCoberturas(cobertura));
  }

  preparaCoberturas() {
    if (!this.coberturasDetalle || this.coberturasDetalle?.length == 0) {
      return;
    }
    this.coberturasDetalle.forEach(cobDet => {
      this.agregarCobertura(cobDet);
    });
  }

  abrirSeccionServicios(asegurado: Servicio) {
    this.habilitaTercero = true;
    this.servicioSelecciona = asegurado;
    this.consultaServiciosInterno(asegurado);
  }

  regresaConsulta() {
    this.habilitaTercero = false;
    this.servicioSelecciona = null;
    this.servicioDetalle = null;
    this.habilitaMotivoEstatus = false;
    this.catServicio = [];
    this.catGrua = [];
    this.catConsultaEventoServicio = [];
    this.catConsultaEstatusConcepto = [];
    this.catConsultaEstatus = [];
    this.catConsultaTipoPase = [];
    this.catConsultaTradcionalTipo = [];
    this.crearFormulario();
    this.cambiosFormulario();
  }

  abrirModalTiposTerceros() {
    const dialog = this.dialog.open(ModalConsultarTercerosComponent, {
      width: '650px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { modulo: 'Servicios', tipoTercero: this.servicioDetalle?.tipo_prestador },
    }).afterClosed().subscribe((data: TerceroComplemento) => {
      if (data) {
        this.procesaSeleccionTercero(data);
      }
    });
  }

  procesaSeleccionTercero(data: TerceroComplemento) {
    const descripcionTer = data.tipo_tercero == 1 ? data.placas : data.desc_tipo_tercero;
    if ((data.tipo_tercero == 4 || data.tipo_tercero == 5)) {
      const servicio = this.formAsegurado.get('tipoServicio')?.value;
      const validaHereda = servicio == '10' || servicio == '17';

      if (validaHereda) {
        this.formAsegurado.patchValue({
          idTercero: data.id_tercero,
          tipoTercero: descripcionTer,
          nombreLesionado: data.nombre,
          apellidoPaterno: data.ap_paterno,
          apellidoMaterno: data.ap_materno,
          edad: data.edad
        });

        ['nombreLesionado', 'apellidoPaterno', 'apellidoMaterno', 'edad'].forEach(campo => {
          this.formAsegurado.get(campo)?.disable();
        });
      }
    }
  }

  consultarProveedores(tipoPrestador: number, sucursal: string) {
    const request = {
      tipoPrestador,
      sucursal,
      clave: null
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaProveedor(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los proveedores.' }));
      },
    })
  }

  guardarServicio() {
    if (!this.formAsegurado.valid) {
      this.abrirSeccionServicios
      this.formAsegurado.markAllAsTouched();
      return this.procesosComplementoService.alertaGeneralComplemento('Aviso', `Es necesario capturar los campos solicitados`, 'warning', false, true);
    }

    if (!this.validaGuardadoServicio()) {
      const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
      let nombreLesionado = this.formAsegurado.get('nombreLesionado').value ? `${this.formAsegurado.get('nombreLesionado').value}|${this.formAsegurado.get('apellidoPaterno').value}|${this.formAsegurado.get('apellidoMaterno').value}` : undefined;
      const fechaArriboConvert = FechaUtils.toDisplay(this.formAsegurado.get('fechaArribo')?.value);

      const request = {
        sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
        linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
        producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
        poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
        endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
        a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
        no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
        cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
        cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
        inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
        num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
        alarma: this.detalleSiniestroCompleto.Siniestro[0].alarma,
        moneda: siniestroFormateado.moneda,
        ramo: siniestroFormateado.ramo,
        sramo: siniestroFormateado.sramo,
        oficina: siniestroFormateado.oficina,
        consecutivo: siniestroFormateado.consecutivo,
        anio: siniestroFormateado.anio,
        responsable: this.detalleSiniestroCompleto.Siniestro[0].respons_sini,
        tipoCliente: 2,
        tipoPrestador: this.servicioDetalle.tipo_prestador,
        numeroLiga: this.servicioDetalle.num_liga,
        tipoServicio: this.servicioDetalle.tipo_prestador,

        sucursalProveedor: this.servicioDetalle.ofnaprov,
        claveProveedor: this.servicioDetalle.cve_prov,
        reporte: this.servicioDetalle.reporte,
        tipoGrua: this.formAsegurado.get('tipoGrua')?.value,
        fechaArribo: fechaArriboConvert,
        horaArribo: this.formAsegurado.get('horaArribo')?.value
          ? this.formAsegurado.get('horaArribo')?.value + ':' + this.formAsegurado.get('minutosArribo')?.value
          : '',
        numeroActaMP: this.formAsegurado.get('numeroActaMP')?.value,
        idTercero: this.servicioDetalle?.id_tercero,
        fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
        evento: this.formAsegurado.get('evento')?.value,
        estatus: this.servicioDetalle?.status,
        estatusServicio: this.formAsegurado.get('estatus')?.value ? this.formAsegurado.get('estatus')?.value : this.servicioDetalle?.status,
        tiempoEsperaHora: this.formAsegurado.get('horasTiempo')?.value,
        tiempoEsperaMinuto: this.formAsegurado.get('minutosTiempo')?.value,
        maniobraMayor: this.formAsegurado.get('maniobraMayor')?.value,
        gruaRescate: this.formAsegurado.get('gruaRescate')?.value,
        blindaje: this.formAsegurado.get('blindaje')?.value,
        resguardo: this.formAsegurado.get('resguardo')?.value,
        foraneo: this.formAsegurado.get('foraneo')?.value,
        medico: this.servicioDetalle?.medico,
        MP: this.formAsegurado.get('mp')?.value == 1 ? 1 : 2,
        homicidio: this.formAsegurado.get('homicidio')?.value == 1 ? 1 : 2,
        totalHomicidios: this.servicioDetalle?.homicidio_total,
        lesionados: this.formAsegurado.get('lesionados')?.value == 1 ? 1 : 2,
        totallesionados: this.servicioDetalle?.lesionados_total,
        danosMateriales: this.formAsegurado.get('danosMateriales')?.value == 1 ? 1 : 2,
        danosEcologicos: this.formAsegurado.get('danosEcologicos')?.value == 1 ? 1 : 2,
        ataquesViasComunicacion: this.formAsegurado.get('ataquesViasComunicacion')?.value == 1 ? 1 : 2,
        nombreLesionado: nombreLesionado ?? undefined,
        edad: this.formAsegurado.get('edad')?.value,
        importe: this.formAsegurado.get('importe')?.value,
        // cadenaCoberturas: this.coberturas?.getRawValue(), //REVIEW
        concesionado: this.formAsegurado.get('concesionado')?.value,
        id_lesionado: this.servicioDetalle?.id_lesionado ?? undefined,

        causa: this.detalleSiniestroCompleto.Siniestro[0].causa,

      }
      console.log(request)
      this.store.dispatch(ActivarLoadingAction());
      this.complementoWebService.actualizaServicio(request).subscribe({
        next: (value) => {
          this.store.dispatch(DesactivarLoadingAction());
          if (value.Resultado != null && value.Exito) {
            this.procesosComplementoService.alertaGeneralComplemento('Guardado', `La información se actualizó correctamente`, 'success', false, true);
            if ([10, 17].includes(this.servicioDetalle.tipo_prestador)) {
              this.guardaLesionado(this.servicioDetalle.id_lesionado, this.servicioDetalle.num_liga);
            } else {
              this.eventosServiciosTercero.emit({ nombre: 'ACTUALIZAR_SERVICIOS', valor: true });
            }
            this.regresaConsulta();
          } else {
            this.procesosComplementoService.alertaGeneralComplemento('Aviso', `${value.Mensaje || 'No se pudo guardar la información del servicio.'}`, 'warning', false, true);

          }
        },
        error: (err) => {
          this.store.dispatch(DesactivarLoadingAction());
          this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos procesar el guardado del servicio.' }));
        }
      });
    }
  }

  consultaServiciosInterno(servicio: Servicio) {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoCliente: 2,
      tipoPrestador: servicio.tipo_prestador,
      numeroLiga: servicio.num_liga,
      causa: this.detalleSiniestroCompleto.Siniestro[0].causa,

    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaServicios(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Servicio.length && value.Exito) {
          this.servicioDetalle = value.Resultado.Servicio[0];
          if (this.servicioDetalle.valida_servicio) {
            this.coberturasDetalle = value.Resultado.Coberturas;
            this.setFormulario();
            this.configuraFormulario();
            // this.preparaCoberturas();
          } else {
            this.procesaResultado();
          }
        } else {
          this.habilitaTercero = false;
          this.servicioSelecciona = null;
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `${value.Mensaje || 'No se pudo consultar la información del servicio.'}`, 'warning', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  procesaResultado(): void {
    const { tipo_prestador, descripl_dato } = this.servicioDetalle;

    const mensajes: Record<number, string> = {
      5: 'grúa',
      16: 'ambulancia',
    };

    const esTipoEspecial = [5, 16].includes(tipo_prestador);
    const mensajeServicio = esTipoEspecial ? mensajes[tipo_prestador] : descripl_dato;
    const accionServicio = esTipoEspecial ? 'cancelado' : 'en asegurados';

    const mensaje = `No es posible recuperar un servicio de ${mensajeServicio} ${accionServicio}, favor de verificar con cabina.`;

    this.procesosComplementoService.alertaGeneralComplemento('Aviso', mensaje, 'warning', false, true);
  }

  setFormulario() {
    const nombreLesionado = this.servicioDetalle?.nombre_lesionado?.split("|");
    const fechaArribo = this.servicioDetalle?.fecha_arribo == null ? this.servicioDetalle?.fecha_reporte : this.servicioDetalle.fecha_arribo;
    const horaArribo = this.servicioDetalle?.hora_arribo == null ? this.servicioDetalle?.hora_reporte : this.servicioDetalle.hora_arribo;
    const tiempoEspera = this.servicioDetalle?.tiempo_espera == null ? null : this.servicioDetalle.tiempo_espera;
    const fechaArriboConvert = FechaUtils.toIso(fechaArribo);

    this.formAsegurado.patchValue({
      idTercero: this.servicioDetalle?.id_tercero,
      tipoPrestador: this.servicioDetalle?.tipo_prestador,
      servicio: this.servicioDetalle?.tipo_prestador,
      tipoTercero: this.servicioDetalle?.desc_tipo_tercero,
      tipoProveedor: this.servicioSelecciona?.desc_tipo_proveedor,
      proveedor: this.servicioDetalle?.desc_proveedor,
      reporte: this.servicioDetalle?.reporte,

      horasTiempo: tiempoEspera ? tiempoEspera?.split(":")[0] : null,
      minutosTiempo: tiempoEspera ? tiempoEspera?.split(":")[1] : null,
      maniobraMayor: this.servicioDetalle?.maniobra_mayor ? 1 : 0,
      gruaRescate: this.servicioDetalle?.grua_rescate ? 1 : 0,
      tipoGrua: this.servicioDetalle?.tipo_grua ? 1 : 0,
      blindaje: this.servicioDetalle?.blindaje ? 1 : 0,
      evento: this.servicioDetalle?.evento,
      resguardo: this.servicioDetalle?.resguardo ? 1 : 0,
      concecionada: this.servicioDetalle?.concesionado,
      foraneo: this.servicioDetalle?.foraneo ? 1 : 0,

      estatus: this.servicioSelecciona?.estatus || this.servicioDetalle?.status,
      arribo: this.servicioSelecciona?.arribo,
      fechaArribo: fechaArriboConvert ? fechaArriboConvert : null,
      horaArribo: horaArribo ? horaArribo?.split(":")[0] : null,
      minutosArribo: horaArribo ? horaArribo?.split(":")[1] : null,
      medicoResponsiva: this.servicioSelecciona?.medico ? 1 : 0,

      lesionado: this.servicioDetalle?.lesionados == 1 ? 1 : 0,
      homicidio: this.servicioDetalle?.homicidio == 1 ? 1 : 0,
      totallesionado: this.servicioDetalle?.lesionados_total,
      totalhomicidio: this.servicioDetalle?.homicidio_total,
      danosMateriales: this.servicioDetalle?.danos_materiales == 1 ? 1 : 0,
      danosEcologicos: this.servicioDetalle?.danos_ecologicos == 1 ? 1 : 0,
      ataquesViaComunicacion: this.servicioDetalle?.ataques_vias_comunicacion == 1 ? 1 : 0,
      motivoEstatus: this.servicioSelecciona?.desc_motivo_estatus,
      mp: this.servicioDetalle?.terceros_mp > 0 ? 1 : this.servicioDetalle?.mp || 2,
      numeroActaMP: this.servicioDetalle?.num_actam,

      tipoLesion: this.servicioSelecciona?.tipoLesion,
      nombreLesionado: nombreLesionado ? nombreLesionado[0] : null,
      apellidoPaterno: nombreLesionado ? nombreLesionado[1] : null,
      apellidoMaterno: nombreLesionado ? nombreLesionado[2] : null,
      edad: this.servicioDetalle?.edad,
      importe: this.servicioDetalle?.importe?.replace(/[$,]/g, ""),
    }, { emitEvent: false, onlySelf: true });
  }

  configuraFormulario() {
    const validaServicio = this.servicioDetalle?.valida_servicio;
    const tipoPrestador = this.servicioDetalle?.tipo_prestador;

    this.actualizarCamposSegunTipoPrestador(tipoPrestador);

    this.formAsegurado.get('servicio').disable({ emitEvent: false });
    this.formAsegurado.get('tipoTercero').disable({ emitEvent: false });
    this.formAsegurado.get('proveedor').disable({ emitEvent: false });
    this.formAsegurado.get('tipoProveedor').disable({ emitEvent: false });

    if (this.servicioDetalle.ofnaprov == 'D00' && this.formAsegurado.get('servicio').value == 5 ? this.servicioDetalle?.cve_prov == 384 : false) {
      this.formAsegurado.get('tipoGrua').setValidators(Validators.required);
      this.formAsegurado.get('tipoGrua').updateValueAndValidity();
    }
  }

  actualizarCamposSegunTipoPrestador(tipoPrestador: number) {
    let estatus = this.servicioDetalle?.status_concepto ?? null;
    let descripcionTipoProveedor = this.servicioDetalle?.desc_tipo_proveedor ?? null;

    let motivoEstatus = '';

    switch (tipoPrestador) {
      case 5:
      case 16:
        if (this.servicioDetalle?.status != 1) {
          estatus = this.servicioDetalle.status;
          this.formAsegurado.get('estatus')?.disable({ emitEvent: false });
          this.formAsegurado.get('mp')?.disable({ emitEvent: false });
        } else {
          this.formAsegurado.get('estatus')?.enable({ emitEvent: false });
          this.formAsegurado.get('estatus')?.setValidators(Validators.required);
          this.formAsegurado.get('estatus')?.updateValueAndValidity({ emitEvent: false });
        }
        break;

      case 15:
        estatus = this.servicioDetalle?.status ?? null;
        motivoEstatus = this.servicioDetalle?.desc_motivo_estatus ?? '';
        if (this.detalleSiniestroCompleto.Siniestro[0].causa != 3 && this.servicioDetalle.mp == 1) {
          this.formAsegurado.get('totallesionado').setValidators([Validators.required]);
          this.formAsegurado.get('totallesionado').updateValueAndValidity();
          this.formAsegurado.get('totalhomicidio').setValidators([Validators.required]);
          this.formAsegurado.get('totalhomicidio').updateValueAndValidity();
        }
        break;
      case 10:
      case 17:
        const tipoPaseTexto = this.catConsultaTipoPase.map(pase => pase.desc_tipo_pase).join('/');
        descripcionTipoProveedor = `${descripcionTipoProveedor}/${tipoPaseTexto}`;
        this.formAsegurado.get('tipoProveedor')?.disable();
        this.formAsegurado.get('tipoLesion')?.disable();

        if ([4, 5].includes(this.servicioDetalle?.tipo_tercero)) {
          this.formAsegurado.get("nombreLesionado").disable();
          this.formAsegurado.get("apellidoPaterno").disable();
          this.formAsegurado.get("apellidoMaterno").disable();
          this.formAsegurado.get("edad").disable();
        }

        break;

      default:
        this.formAsegurado.get('estatus')?.enable({ emitEvent: false });
        this.formAsegurado.get('tipoProveedor')?.enable();
        break;
    }

    if (estatus == 2 && [5, 15, 16].includes(tipoPrestador)) {
      this.habilitaMotivoEstatus = true;
    }

    this.formAsegurado.patchValue({
      tipoProveedor: descripcionTipoProveedor,
      estatus,
      motivoEstatus
    }, { emitEvent: false, onlySelf: true });
  }

  validaGuardadoServicio(): boolean {
    let estatus = this.formAsegurado.get('estatus').value;
    let evento = this.formAsegurado.get('evento').value;
    let tipoPrestador = this.formAsegurado.get('tipoPrestador').value;
    let importe = this.formAsegurado.get('importe').value;

    // Solo asegurados
    if ([5, 16].includes(tipoPrestador) && evento != 2 && estatus == 1) {
      //Valdiacion de hora arribo mayor al registro
    }

    let requeridos = false;
    let mensaje = '';

    const coberturas = this.coberturas;
    const cantidadCoberturasActivas = coberturas.controls.filter(ctrl => ctrl.get('activa')?.value).length;
    const cantidadCoberturasSinImporte = coberturas.controls.filter(ctrl => ctrl.get('estimacion')?.value > 0).length;

    switch (tipoPrestador) {
      case '1':
      case '3':
        if (cantidadCoberturasActivas === 0) {
          requeridos = true;
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se puede estimar debido a que no hay coberturas vigentes.`, 'warning', false, true);
        }
        break;
      case '15':
        if ([15].includes(this.formAsegurado.get('servicio').value) && this.formAsegurado.getRawValue().reporte == null) {
          requeridos = true;
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `Es necesario contar con un número de reporte`, 'warning', false, true);
        }
        break;
      case '23':
        if ([23].includes(this.formAsegurado.get('servicio').value) && this.formAsegurado.getRawValue().tipoTercero == null) {
          requeridos = true;
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `Es necesario seleccionar un tercero`, 'warning', false, true);
        }
        break;
      case '10':
      case '17':
        if (!requeridos) {
          if (cantidadCoberturasSinImporte) {
            requeridos = true;
            this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se puede actualizar debido a que el importe tiene que ser mayor a cero.`, 'warning', false, true);
            this.coberturas.markAllAsTouched();
          }
        }
        break;
    }

    return requeridos
  }

  guardaLesionado(idLesionado: number, numLiga: number) {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    let nombreLesionado = `${this.formAsegurado.get('nombreLesionado').value}|${this.formAsegurado.get('apellidoPaterno').value}|${this.formAsegurado.get('apellidoMaterno').value}`;
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      poliza: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      responsable: this.detalleSiniestroCompleto.Siniestro[0].respons_sini,
      tipoCliente: 2,
      nombre: nombreLesionado,
      edad: this.formAsegurado.get('edad')?.value ?? 0,
      importe: this.formAsegurado.get('importe')?.value,
      tipo: 1,
      proveedor: this.formAsegurado.get('proveedor')?.value ?? "",
      id_lesionado: this.servicioDetalle?.id_lesionado ?? idLesionado,
      id_tercero: this.servicioDetalle?.id_tercero,
      numeroLiga: this.servicioDetalle?.num_liga ?? numLiga,
      modulo: "Servicios"
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.guardaActualizaLesionado(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null && (!value.Mensaje.includes("No") && !value.Mensaje.includes("Error") && !value.Mensaje.includes("problema"))) {
          this.procesosComplementoService.alertaGeneralComplemento('Guardado', `La información se guardó correctamente`, 'success', false, true);
          this.regresaConsulta();
          this.eventosServiciosTercero.emit({ nombre: 'ACTUALIZAR_SERVICIOS', valor: true });
        } else {
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `${value.Mensaje || 'No se pudo guardar la información'}.`, 'warning', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del lesionado.' }));
      },
    })
  }

  actualizaValidadores(
    form: FormGroup,
    campos: string[],
    operacion: 'agregar' | 'quitar',
    validadores: ValidatorFn[] = []
  ): void {
    campos.forEach(campo => {
      const control = form.get(campo);
      if (!control) return;

      if (operacion === 'quitar') {
        control.clearValidators();
        control.setValidators(null);
      } else if (operacion === 'agregar') {
        control.setValidators(validadores);
        if (!['fechaArribo'].includes(campo)) control.setValue(null, { onlySelf: true });
      }
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  validaCheck(evento: MatCheckboxChange, tipo: string) {
    if (!evento.checked) {
      const tipoAccion = tipo == 'totallesionado' ? 'Lesionados' : 'Homicidios';
      const tipoAccionF = tipo == 'totallesionado' ? 'lesionado' : 'homicidio';
      this.procesosComplementoService.alertaGeneralComplemento('Aviso', `¿Esta seguro de no marcar ${tipoAccion}`, 'question', true, true).then(
        (result) => {
          if (result.isConfirmed) {
            this.formAsegurado.get(tipo).setValue(null);
          } else {
            this.formAsegurado.get(tipoAccionF).setValue(true);
          }
        }
      );
    }
  }
}
